<!--商品详情-->
<template>
  <div class="box">
    <div class="write-box">
      <van-field
        v-model="formData.content"
        rows="5"
        autosize
        label=""
        type="textarea"
        placeholder="请输入评价内容"
        show-word-limit
      />
    </div>

    <PicUploader :fileList="formData.pics" :limit="9" @imageListChange="imageListChange"
                 :name="'pics'"></PicUploader>

    <div class="star-box">
      <div class="star-title">请选择星级</div>
      <van-rate v-model="formData.star"
                :size="25"
                color="#ffd21e"
                void-icon="star"
                void-color="#eee"/>
    </div>

    <div class="submit-box">
      <div class="submit-btn" @click="submit">
        <van-button type="danger" round size="large">发表评论</van-button>
      </div>
    </div>
  </div>
</template>
<style scoped>

  .write-box {
    border-bottom: 1px solid #eee;
  }

  .star-box {
    padding-left: 15px;
  }

  .star-title {
    padding-bottom: 10px;
  }

  .submit-box {
    position: fixed;
    bottom: 20px;
    width: 100%;
  }

  .submit-btn {
    margin: 0 15px;
  }
</style>

<script>
    import Vue from "vue";
    import PicUploader from "@/components/picker/PicUploader.vue";

    import {
        Cell,
        CellGroup,
        GoodsAction,
        GoodsActionIcon,
        GoodsActionButton,
        Sku,
        Toast
    } from "vant";

    Vue.use(Cell)
        .use(CellGroup)
        .use(GoodsAction)
        .use(GoodsActionIcon)
        .use(GoodsActionButton)
        .use(Sku)
        .use(Toast);

    export default {
        name: "OrderCommentOperate",
        components: {
            PicUploader
        },
        data: function () {
            return {
                goodsId: 0,
                formData: {
                    order_id: 0,
                    goods_id: 0,
                    content: '',
                    star: 0,
                    pics: []
                }
            };
        },
        filter: {},
        activated() {
        },
        mounted() {
            document.title = "商品评价添加";
            let that = this;
            that.goodsId = that.formData.goods_id = that.$route.query.id
            that.formData.order_id = that.$route.query.order_id
        },
        destroyed() {
        },
        methods: {
            // 跳转商品视频
            imageListChange(data) {

                console.log('data', data)
                let that = this;
                let name = data.name
                that.formData[name] = data.pic
            },

            submit() {
                let that = this
                //判断是否输入素材描述
                if (that.formData.content == '') {
                    Toast('请输入文字描述')
                }
                //判断是否上传图片
                if (that.formData.pics == []) {
                    Toast('请上传图片')
                }
                //请求增加素材的接口
                that.$api.post('/api/goods/materialAdd', that.formData, (res) => {
                    Toast.success('提交成功,等待管理员审核~');
                    setTimeout(() => {
                        that.$router.go(-1)
                    }, 2000)
                }, res => {
                    Toast(res.msg)
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// OrderCommentOperate.vue?45b74085